// import ReactChatbot from "./chatbot/ReactChatbot"
import "./css/floatBtnlist.css"
import FbBtn from "./btns/FbBtn"
import PhoneBtn from "./btns/PhoneBtn"
import WhatsAppBtn from "./btns/WhatsAppBtn"

const FloatBtnList = ({ data }) => {
  const mtArray = Array.isArray(data?.content?.mt) ? data.content.mt : []
  const phone = mtArray.find((item) => item.label === "phone")?.description || "25388300"
  const whatsappNum = mtArray.find((item) => item.label === "whatsapp")?.description || "92840210"
  const fbLink = mtArray.find((item) => item.label === "facebook")?.description || "https://www.facebook.com/profile.php?id=100076074545255"
  return (
    <div className="floatBtnList">
      <div className="floatBtnList-item">
        <PhoneBtn phone={phone} />
      </div>
      <div className="floatBtnList-item">
        <WhatsAppBtn phone={whatsappNum} />
      </div>
      <div className="floatBtnList-item">
        <FbBtn src={fbLink} />
      </div>
      {/* <div className="floatBtnList-item">
        <ReactChatbot />
      </div> */}
    </div>
  )
}

export default FloatBtnList
